import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface IUserConfigurationInitialState {
  entityId?: string;
  entityName?: string;
  entityUrl?: string;
  lenderId: string;
  lenderName?: string;
  agencyId?: string;
  agencyName?: string;
  lenderLogo?: string;
  userGroup?: string;
  caUserId: string;
  isLoading: boolean;
  error: { message?: string };
  userRole?: string;
  caUserName?: string;
}

export const userConfigurationInitialState: IUserConfigurationInitialState = {
  entityId: '',
  entityName: '',
  caUserId: '',
  entityUrl: '',
  lenderId: '',
  lenderName: '',
  agencyId: '',
  agencyName: '',
  isLoading: false,
  error: {},
  userRole: '',
  caUserName: '',
};

const userConfigurationSlice = createSlice({
  name: 'userInformation',
  initialState: userConfigurationInitialState,
  reducers: {
    setUserConfiguration: (
      state,
      {
        payload,
      }: PayloadAction<{
        entityId?: string;
        entityName?: string;
        entityUrl?: string;
        caUserId?: string;
        caUserName?: string;
        lenderId: string;
        lenderName?: string;
        agencyId: string;
        agencyName?: string;
        lenderLogo?: string;
        userGroup?: string;
        userRole: string;
      }>
    ) => {
      state.entityId = payload.entityId;
      state.entityName = payload.entityName;
      state.entityUrl = payload?.entityUrl;
      state.userGroup = payload?.userGroup;
      state.userRole = payload?.userRole;
      state.lenderId = payload.lenderId;
      state.lenderName = payload?.lenderName;
      state.agencyId = payload.agencyId;
      state.agencyName = payload?.agencyName;
      if (payload?.caUserId) state.caUserId = payload?.caUserId;
      if (payload?.caUserName) state.caUserName = payload?.caUserName;
    },
    updateLenderIdInUserConfiguration: (
      state,
      {
        payload,
      }: PayloadAction<{
        lenderId: string;
        lenderName: string;
        lenderLogo: string;
      }>
    ) => {
      state.lenderId = payload.lenderId;
      state.lenderName = payload.lenderName;
      state.lenderLogo = payload.lenderLogo;
    },
    updateAgencyIdInUserConfiguration: (
      state,
      { payload }: PayloadAction<{ agencyId: string; agencyName: string }>
    ) => {
      state.agencyId = payload.agencyId;
      state.agencyName = payload.agencyName;
    },
    updateEntityIdInUserConfiguration: (
      state,
      { payload }: PayloadAction<{ entityId: string }>
    ) => {
      state.entityId = payload.entityId;
    },
    updateEntityDataInUserConfiguration: (
      state,
      {
        payload,
      }: PayloadAction<{
        entityId: string;
        entityName: string;
        userRole: string;
        userGroup: string;
        userName: string;
        userId: string;
      }>
    ) => {
      state.entityId = payload.entityId;
      state.entityName = payload.entityName;
      state.userGroup = payload.userGroup;
      state.userRole = payload.userRole;
      state.caUserName = payload.userName;
      state.caUserId = payload.userId;
    },
    resetUserConfigurationState: () => userConfigurationInitialState,
  },
});

export const {
  setUserConfiguration,
  resetUserConfigurationState,
  updateLenderIdInUserConfiguration,
  updateAgencyIdInUserConfiguration,
  updateEntityIdInUserConfiguration,
  updateEntityDataInUserConfiguration,
} = userConfigurationSlice.actions;

export default userConfigurationSlice.reducer;
